import { FormattedMessage } from 'react-intl';
import { CardExpiryElement } from '@stripe/react-stripe-js';
import messages from './LinkDebitCard.messages';
import styles from './LinkDebitCard.module.css';
import { stripeElementStyles } from './StripeElementStyles';

export const ExpiryDateQuestion = ({
    error,
    onChange
}: {
    error: boolean | null;
    onChange: (response: any) => void;
}) => {
    return (
        <div className={styles.expiryDateWrapper}>
            <label className={styles.label}>
                <FormattedMessage {...messages.expiryDate} />
            </label>
            {error && (
                <span className={styles.error}>
                    <FormattedMessage {...messages.expiryDateError} />
                </span>
            )}
            <CardExpiryElement
                onChange={onChange}
                options={{ style: stripeElementStyles }}
            />
        </div>
    );
};
